import React, { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { GetErrorPageUrl } from "src/actions/GetErrorPageUrl";
import { hasAssociatedProvider } from "src/actions/HasAssociatedProvider";
import { getSelectedProvider } from "src/actions/SelectProvider";
import { Button, Loading } from "src/components";
import Stack from "src/components/Stack/Stack";
import { AuthContext } from "src/contexts/AuthContext";
import { sendEvent } from "src/hooks/analytics";
import { Divider, PageContainer } from "../styles";
import { SuccessIcon } from "../Success/Icon";
import { MobileBreak, Text, TextList, Title, TitleList } from "./style";

export const VerifyAssociations = () => {
  const [loading, setLoading] = useState(true);
  const { user, authenticate } = useContext(AuthContext);
  const provider = getSelectedProvider();
  const navigate = useNavigate();

  useEffect(() => {
    authenticate();
  }, []);

  useEffect(() => {
    if (!user) return;

    const selectedProvider = getSelectedProvider();
    if (!selectedProvider) return;

    hasAssociatedProvider(user.globoId, selectedProvider.id)
      .then(associated => {
        if (associated === false) {
          navigate("/redirect");
          return;
        }

        sendEvent(
          "alf_page_view",
          {
            user_code_provider_hit: "cadun",
            page_name_custom: "conta_ja_associada",
            provider_name: selectedProvider.name
          },
          { user_code: user.globoId, user_code_provider: "cadun" }
        );

        setLoading(false);
      })
      .catch(() => {
        navigate(GetErrorPageUrl());
      });
  }, [user, navigate]);

  const handleGloboplayButton = () => {
    sendEvent(
      "component_click",
      {
        component_name: "botao_assistir_globoplay",
        component_type: "button",
        component_item_link_redirect: localStorage.getItem("callbackUrl") || "",
        page_name_custom: "conta_ja_associada",
        provider_name: provider!.name
      },
      { user_code: user!.globoId, user_code_provider: "cadun" }
    );

    window.location.href = localStorage.getItem("callbackUrl") || "";
    return;
  };

  const handleProviderButton = () => {
    sendEvent(
      "component_click",
      {
        component_name: "botao_login_operadora",
        component_type: "button",
        component_item_link_redirect: "/redirect",
        page_name_custom: "conta_ja_associada",
        provider_name: provider!.name
      },
      { user_code: user!.globoId, user_code_provider: "cadun" }
    );

    navigate("/redirect");
    return;
  };

  if (!provider) {
    return <Navigate to={GetErrorPageUrl()} />;
  }

  if (loading || !user) {
    return <Loading />;
  }

  return (
    <PageContainer>
      <Stack direction={"column"} spacing={{ mobile: 48, desktop: 64 }}>
        <Stack direction={"column"} spacing={32} alignItems={"center"}>
          <Stack direction={"column"} spacing={{ mobile: 16, desktop: 24 }}>
            <Stack
              direction={{ mobile: "column", tablet: "row" }}
              spacing={{ mobile: 16, desktop: 24 }}
              alignItems={"center"}
            >
              <SuccessIcon />
              <Title>Conta já associada</Title>
            </Stack>
            <Text $mobileTextAlign="center" $tabletTextAlign="left">
              Você já associou essa conta com a {provider.name} e ativou uma
              assinatura antes.
            </Text>
          </Stack>

          <Button onClick={handleGloboplayButton}>Assistir Globoplay</Button>
        </Stack>

        <Divider />

        <Stack direction={"column"} spacing={{ mobile: 24, tablet: 32 }}>
          <TitleList>Está tendo problemas?</TitleList>

          <Stack direction={"column"} spacing={16}>
            <Text>Para tentar resolver, você pode:</Text>

            <TextList>
              <li>
                Continuar a associação indo para <MobileBreak /> o{" "}
                <a onClick={handleProviderButton}>login da operadora.</a>
              </li>
              <li>
                Sair da sua conta nos dispositivos e <MobileBreak />
                entrar novamente.
              </li>
            </TextList>
          </Stack>
        </Stack>
      </Stack>
    </PageContainer>
  );
};
